import debug from "debug";
import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/ajax-validate';
const log = debug(MODULE_NAME);

const ELEMENT_SELECTOR = '[data-ajax-validate]';
const CONTAINER_SELECTOR = '[data-ajax-container]';
const PROGRESS_CLASS = 'has-progress';

class AjaxValidate {
    constructor(element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$submitButton = $('[type="submit"]', element);
        log('AjaxValidate', element, options);
        this.watch();
    }

    onSubmit(event) {
        event.preventDefault();

        const form = this.$element;
        this.$submitButton
            .attr('disabled','disabled')
            .addClass(PROGRESS_CLASS);

        $.ajax({
            type: 'POST',
            url: form[0].action,
            data: form.serialize()
        })
            .done(function(result, status, xhr) {
                const contentType = xhr.getResponseHeader('content-type') || '';
                const container = form.closest(CONTAINER_SELECTOR);
                const context = container.parent();

                if (contentType.indexOf('json') > -1) {
                    document.location = result.ReturnUrl;
                } else {
                    container.replaceWith($(result));

                    //  Rebind newly inserted form
                    context.find(ELEMENT_SELECTOR).ajaxValidate({reloaded:true});

                    $(document).trigger('async_update', context.find(ELEMENT_SELECTOR));
                }
            })
            .error(function() {
                log(arguments);
                this.$submitButton
                    .removeClass(PROGRESS_CLASS)
                    .removeAttr('disabled');
            });
    }

    watch() {
        this.$element.on('submit.ajaxvalidate', this.onSubmit.bind(this));
        log('bound', this.element);
    }

    unwatch() {
        this.$element.off('.ajaxvalidate');
        log('unbound', this.element);
    }
}

AjaxValidate.DEFAULTS = {};

plugin('ajaxValidate', AjaxValidate);

export function exec() {
    $(document).ready(() => {
        log('binding');
        $(ELEMENT_SELECTOR).ajaxValidate();
        log('bound');
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/ajax-validate/index.js